const endpoint = "https://sepb.cuba-go.com"
const cpoint = "https://central-backend.cuba-go.com"

const mediapoint = `${endpoint}`
const startpoint = `${cpoint}/sep/`

export { endpoint, mediapoint, startpoint }
